import { getPageCluster } from '@shared/domain/PageCluster.ts';
import type { FrontendTrackingLabels } from '@shared/tracking/TrackingLabels';
import type { SelectionEvents } from '@tilelist/application/ports/SelectionEvents.ts';

/*                                                                                              */
export function frontendPageViewTracking(historic: boolean, selectionEvents: SelectionEvents): FrontendTrackingLabels {
    const pageCluster = getPageCluster() || 'UNKNOWN';

    const pageViewTracking: FrontendTrackingLabels = {
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster,
        'wk.san_EntrySelectionRule': selectionEvents.current().entryRule,
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    return pageViewTracking;
}
